/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

import { register } from '@shopify/theme-sections';
import ProductForm from '../components/productForm';

const classes = {
  hide: 'hide',
};

const selectors = {
  productForm: "[data-product-form]"
};

register("product", {
  async onLoad() {
    const productFormElement = document.querySelector(selectors.productForm);
    ProductForm().init();
  },
  onUnload() {

  }
});